
<template>
  <div id="app">
    <vue-particles id="tsparticles" :loaded="particlesLoaded" :options="aaaa" />
    <el-container style="min-height: 100vh; min-width: 1280px">
      <el-backtop></el-backtop>
      <el-header style="height: auto" class="home-gradient">
        <div class="title-bg">
          <div
            class="content-width"
            style="width: 1250px; display: flex; justify-content: space-between"
          >
            <div
              class="v-center titlePNG-bg"
              style="background: url(/pic/radiopharm.png) 0% 0% / contain"
            >
              <div
                style="
                  position: absolute;
                  cursor: pointer;
                  top: 29px;
                  height: 34px;
                  width: 218px;
                  left: 334px;
                  text-align: right;
                "
                @click="playAudio"
                title="Click to Read Radiopharm"
              >
                <img
                  src="/pic/play.png"
                  style="display: initial; width: 27px; margin-top: 4px"
                />
                <audio
                  ref="audio"
                  :src="`/pic/Radiopharm.mp3`"
                  preload="auto"
                ></audio>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 60px" class="content-width">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;
            "
          >
            <el-menu
              class="el-menu-demo"
              mode="horizontal"
              background-color="#455da500"
              text-color="#fff"
              style="margin: auto 0"
            >
              <el-menu-item>
                <router-link to="/" class="no-line"
                  ><i class="fa fa-home" aria-hidden="true"></i>
                  Home</router-link
                >
              </el-menu-item>

              <el-submenu index="4">
                <template slot="title">
                  <i class="fa fa-search-plus" aria-hidden="true"></i>
                  Search</template
                >
                <el-menu-item class="submenu-item">
                  <router-link
                    to="/search-drug-page"
                    class="no-line"
                    style="color: black"
                  >
                    Search for Radiopharmaceuticals</router-link
                  >
                </el-menu-item>
                <el-menu-item class="submenu-item">
                  <router-link
                    to="/search-radionuclide-page"
                    class="no-line"
                    style="color: black"
                  >
                    Search for Radionuclide</router-link
                  >
                </el-menu-item>
                <el-menu-item class="submenu-item">
                  <router-link
                    to="/search-target-page"
                    class="no-line"
                    style="color: black"
                  >
                    Search for Target</router-link
                  >
                </el-menu-item>
                <el-menu-item class="submenu-item">
                  <router-link
                    to="/search-disease-page"
                    class="no-line"
                    style="color: black"
                  >
                    Search for Disease</router-link
                  >
                </el-menu-item>
              </el-submenu>

              <!-- <el-menu-item>
                <router-link to="/to-be-available" class="no-line"
                  ><i
                    class="fa fa-list"
                    aria-hidden="true"
                    style="margin-bottom: 5px"
                  ></i
                  >Browse</router-link
                >
              </el-menu-item> -->

              <el-menu-item>
                <router-link to="/download" class="no-line"
                  ><i class="fa fa-cloud-download" aria-hidden="true"></i
                  >Download</router-link
                >
              </el-menu-item>

              <el-menu-item>
                <router-link to="/manual" class="no-line"
                  ><i class="fa fa-file-text-o" aria-hidden="true"></i
                  >Manual</router-link
                >
              </el-menu-item>

              <el-menu-item>
                <router-link to="/contact" class="no-line"
                  ><i class="fa fa-address-book-o" aria-hidden="true"></i
                  >Contact</router-link
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <br />
      <el-footer id="page-foot" style="height: auto" class="home-gradient">
        <div id="page-foot-row" style="height: 266px">
          <el-row class="content-width" style="display: flex; height: 100%">
            <el-col :style="{ flex: '0 0 34%' }">
              <h3 class="foot-title"><b>Cite RadioPharm</b></h3>
              <div class="foot-content">
                <p>
                  J. Liu, X. G. Liu, Y. S. Zhang, X. D. Li, Y. J. Sun, T. T. Li, L. F. Wei, M. J. Mou, H. Yang, P. F. Yuan, X. Li, Z. Y. Zhang, Y. H. Jia, Y. Fu, Y, T. Zhang*, Y. Zhang*, Q. Z. Jia*, F. Zhu*
                  RadioPharm: the database of radiopharmaceuticals (RPs).
                  <a href="https://doi.org/10.1093/nar/gkaf1021" target="_blank"
                    ><b><i>Nucleic Acids Research</i></b></a
                  >. doi: 10.1093/nar/gkaf1021 (2025). 
                   <a
                    href="https://pubmed.ncbi.nlm.nih.gov/41099609/"
                    target="_blank"
                    >PMID: 41099609</a
                  >.
                </p>
              </div>
            </el-col>
            <el-col :style="{ flex: '0 0 33%' }">
              <h3 class="foot-title"><b>Visitor Map</b></h3>
              <div
                class="foot-content"
                style="text-align: center; padding-top: 18px"
              >
                <iframe
                  style="transform: scale(1.23)"
                  :src="iframe_url"
                  frameborder="0"
                ></iframe>
              </div>
            </el-col>
            <el-col :style="{ flex: '0 0 33%' }">
              <h3 class="foot-title"><b>Correspondence</b></h3>
              <div class="foot-content">
                <p style="margin-top: 15px">
                  <b
                    >Prof. Feng Zhu&nbsp; (<a
                      href="mailto:zhufeng@zju.edu.cn"
                      class="contact"
                      style="color: #fbfbfb"
                      >zhufeng@zju.edu.cn</a
                    >)
                    <!-- <a
                      href="https://www.idrblab.org/Peoples-PI.php"
                      target="_blank"
                      style="color: #fff"
                    >
                      <i class="fa fa-external-link" aria-hidden="true"></i></a
                  > -->
                    <!-- <a
                      href="https://idrblab.org/zhufeng.php"
                      target="_blank"
                    >
                      <i class="fa fa-external-link" aria-hidden="true"></i></a
                  > -->
                  </b>
                </p>
                <p>
                  College of Pharmaceutical Sciences, Zhejiang University,
                  Hangzhou, China.
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>


<script>
import pathUrl from "./api/path";

export default {
  name: "App",
  data() {
    return {
      localUrl: pathUrl.localUrl,
      isCollapse: false,
      iframe_url: `${pathUrl.localUrl}/files/visitermap`,
      test: ["a", "b"],

      particlesLoaded: false, // 初始化 particlesLoaded 属性

      aaaa: {
        detectRetina: true, // 启用视网膜屏幕检测，以提高高分辨率屏幕上的粒子显示效果。
        fpsLimit: 60, // 限制动画帧率为60帧每秒，避免过高的帧率消耗过多的资源。
        interactivity: {
          detectsOn: "canvas", // 设置交互检测的元素为画布。
          events: {
            onClick: {
              enable: true, // 启用点击事件。
              mode: "push", // 点击时触发“push”模式，生成新粒子。
            },
            onDiv: {
              elementId: "repulse-div", // 指定一个元素ID，当与该元素交互时触发特定模式。
              enable: false, // 禁用该元素的交互。
              mode: "repulse",
            },
            onHover: {
              enable: true,
              mode: "bubble",
              parallax: {
                enable: false,
                force: 60,
                smooth: 10,
              },
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 1,
              size: 40,
              speed: 3,
            },
            connect: {
              distance: 80,
              lineLinked: {
                opacity: 0.5,
              },
              radius: 60,
            },
            grab: {
              distance: 400,
              lineLinked: {
                opacity: 1,
              },
            },
            push: {
              quantity: 4,
            },
            remove: {
              quantity: 2,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          lineLinked: {
            blink: false,
            color: "#000",
            consent: false,
            distance: 150,
            enable: false,
            opacity: 0,
            width: 0,
          },
          rotate: {
            value: 0,
            random: true,
            direction: "clockwise",
            animation: {
              enable: true,
              speed: 3,
              sync: false,
            },
          },
          move: {
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
            bounce: false,
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 0.6,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            limit: 0,
            value: 150,
          },

          opacity: {
            animation: {
              enable: false,
              minimumValue: 0.1,
              speed: 1,
              sync: false,
            },
            random: false,
            value: 0.15,
          },

          shape: {
            options: {
              character: {
                fill: false,
                font: "Verdana",
                style: "",
                value: "*",
                weight: "4",
              },
              image: [
                {
                  src: "/bg-img/Antibody-based RP.png",
                },
                {
                  src: "/bg-img/Compound-based RP.png",
                },
                {
                  src: "/bg-img/Element-based RP.png",
                },
                {
                  src: "/bg-img/MicrosphereNanoconstruct-based RP.png",
                },
                {
                  src: "/bg-img/Peptide-based RP.png",
                },
              ],
            },
            type: "image",
            polygon: {
              nb_sides: 5,
            },
            stroke: {
              color: "#000000",
              width: 0,
            },
          },
          size: {
            animation: {
              enable: false,
              minimumValue: 0.1,
              speed: 40,
              sync: false,
            },
            random: false,
            value: 15,
          },
        },
        polygon: {
          draw: {
            enable: false,
            lineColor: "#ffffff",
            lineWidth: 0.5,
          },
          move: {
            radius: 10,
          },
          scale: 1,
          type: "none",
          url: "",
        },
      },
    };
  },

  components: {
    // AboutView,
  },
  methods: {
    playAudio() {
      this.$refs.audio.play();
    },
  },
};
</script>


<style lang="less">
// @import '~css-doodle/css-doodle.min.css';

@purple: #455da500;

#app {
  font-family: Harding, "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.content-width {
  width: 1250px;
  margin: 0px auto !important;
}
.el-menu-item:hover,
.el-submenu:hover {
  outline: 0;
  background-color: #bce9f04f !important;
  border-radius: 10px;
}

p {
  margin: 5px 0;
}

h3 {
  margin: 15px 0;
}

.el-menu--horizontal {
  // display: block !important;
  .el-submenu__title {
    border-radius: 10px;
    font-size: 24px;
    padding-right: 0;
  }
  .el-submenu__title:hover {
    background-color: #bce9f04f !important;
  }
  .el-submenu__icon-arrow {
    margin-top: 6px !important;
  }
  .el-menu-item,
  .el-submenu {
    border-radius: 10px;
    font-size: 24px;
    font-weight: bold;
    padding: 0px;
    // margin: 0 52px 0 0;
  }
  .el-menu {
    .el-menu-item {
      height: 60px !important;
      padding: 10px !important;
    }
  }
}

.el-menu--popup {
  background: #fff !important;
  border-radius: 5px !important;
  padding: 5px 0 !important;
  border: 1px dashed #85858552 !important;
  box-shadow: 4px 5px 6px 0px #a1a1a1 !important;
}
.el-header,
.el-main,
.el-footer {
  padding: 0 !important;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px !important;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

body {
  display: block;
  margin: 0;
  line-height: 1.42857;
  font-size: 20px;
}

.foot-title {
  color: #ffffff;
  border-bottom: 3px solid #fff;
  font-size: 24px;
  text-align: left;
  padding-top: 10px;
}

.foot-content {
  color: #ffffff;
  text-align: left;
  font-size: 16px;
  line-height: 1.6;
}

.el-row {
  margin: 0 3%;
  margin-bottom: 20px;
}

.el-col {
  padding: 0 20px;
}

.el-menu-item,
.el-submenu {
  i {
    color: #ffffff !important;
    margin-right: 10px;
    font-size: 24px !important;
    margin-bottom: 8px;
  }
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #409eff00 !important;
  color: #ffffff !important;
}

.no-line {
  text-decoration: none !important;
  padding: 17px;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
  }
  a.router-link-exact-active {
    color: #42b983;
  }
}
.el-main {
  overflow: hidden;
}
.el-button,
.fs20,
.el-tag,
.el-message-box__content,
.el-upload-list__item,
.el-notification__content,
.el-select-dropdown__item,
.el-input--suffix .el-input__inner,
.el-input {
  font-size: 20px !important;
}
.el-backtop {
  box-shadow: 0 0 6px 1px #03a9f4 !important;
}
.home-gradient {
  background: #2c3e50;
}

.el-loading-mask {
  border-radius: 10px;
}

.submenu-item {
  background: #fff !important;
  color: #000 !important;
  border-radius: 0 !important;
  font-size: 20px !important;
}
.submenu-item:hover {
  background: #ff584c30 !important;
}

.title-bg {
  height: 227px;
  background: #fbfbfb;
  // background: linear-gradient(
  //   to bottom,
  //   rgb(255 246 219) 0%,
  //   rgb(242 242 242) 26%,
  //   rgb(232 241 249) 60%,
  //   rgb(235 244 228) 100%
  // );
}
#tsparticles {
  // width: 100%;
  // height: 100%;
  /* position: absolute;   */
  position: fixed;

  z-index: -1;
}
.titlePNG-bg {
  height: 227px;
  width: 1250px;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  position: relative;
}
</style>

